<template>
<div class="rules" :style="{backgroundImage:'url('+require('../../assets/images/invite/inviteRulePageBg.png')+')'}">
  <TopBack :title="title" />
  <div class="contentBox">
    <div class="tableDataBox" :style="{backgroundImage:'url('+require('../../assets/images/invite/teamDataTableCardBg.png')+')'}" v-if="ruleType !=='0'">
      <div class="head">
        <div class="column" :style="{width: columnWith1 + 'vw'}">{{$t('lang.invitee.teamLevel')}}</div>
        <div class="column" :style="{width: columnWith2 + 'vw'}">{{$t('lang.invitee.teamMember')}}</div>
        <div class="column" :style="{width: columnWith3 + 'vw'}">{{$t('lang.invitee.subDeposit')}}</div>
        <div class="column" :style="{width: columnWith4 + 'vw'}">{{$t('lang.invitee.dCommission')}}</div>
        <div class="column" :style="{width: columnWith5 + 'vw'}">{{$t('lang.invitee.bCommission')}}</div>
      </div>
      <div class="body">
        <div class="row" v-for="(item,index) in LevelConfig" :key="index">
          <div class="column" :style="{width: columnWith1 + 'vw'}">{{item.Level}}</div>
          <div class="column" :style="{width: columnWith2 + 'vw'}">{{item.TeamMembers}}</div>
          <div class="column" :style="{width: columnWith3 + 'vw'}">{{item.SubDepositAmount}}</div>
          <div class="column" :style="{width: columnWith4 + 'vw'}">{{item.DepositRate}}%</div>
          <div class="column" :style="{width: columnWith5 + 'vw'}">{{item.BetRate}}%</div>
        </div>
      </div>
    </div>
    <div class="ruleBox">
      <div class="title">{{$t('lang.invitee.rules')}}</div>
      <div class="ruleContent" v-html="replaceRow($t('lang.invitee.rulesContent' + ruleType))"></div>
    </div>
  </div>

</div>
</template>

<script>
import request from '@/service'
import TopBack from '@/components/TopBack/index'
export default {
  name: 'rules',
  components: {
    TopBack
  },
  data () {
    return {
      title: '',
      ruleType: '',
      rule: '1.The betting reward amount depends on how many friends you invite.The more friends you invite, the higher your bonus percentage will be.\n2.Betting rewards are only calculated based on bets placed using real deposits.If your friends place bets using platform bonuses or free credits, no invite reward will be given.\n3.You can directly credit your rewards to your wallet balance from the page.\n 4.The system calculates betting rewards every 24 hours.Please claim your reward after 12:00 PM every day.',
      columnWith1: 14,
      columnWith2: 18,
      columnWith3: 18,
      columnWith4: 20,
      columnWith5: 18,
      LevelConfig: []
    }
  },
  mounted () {
    this.ruleType = this.$route.query.ruleType
    console.log(this.ruleType)
    switch (this.ruleType) {
      case '0':
        this.title = this.$t('lang.invitee.newValidInviteesBonus')
        break
      case '1':
        this.title = this.$t('lang.invitee.teamBetCommission')
        break
      case '2':
        this.title = this.$t('lang.invitee.teamDepositCommission')
        break
    }
    this.getLevelConfig()
  },
  methods: {

    getLevelConfig () {
      const url = '/innovation/invite_relation/get/level/config'
      request('get', url).then(res => {
        if (res) {
          this.LevelConfig = res
        }
      })
    },
    replaceRow (val) {
      if (val) {
        return String(val).replace(/\n/g, '<br>')
      }
    }
  }
}
</script>
<style lang="less">
#app {
  #viewContainer {
   overflow: hidden;
  }
}
</style>
<style lang="less" scoped>
.rules{
  padding-top: 55px;
  width:  100%;
  height: 100vh;
  overflow:hidden;
  background-size: 110% 100%;
  background-position-y: 56px;
  background-position-x: -2vw;
}
.contentBox{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 5vw;
}
.tableDataBox{
  width: 100%;
  height: 58vw;
  background-size: 100% 100%;
  margin-top: 4vw;
  display: flex;
  flex-direction: column;
  font-size: 3.1vw;
  font-weight: 700;
  padding: 0 1vw;
  .head{
    width: 100%;
    height: 11vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .column{
      text-align: center;
    }
  }
  .body{
    width: 100%;
    flex: 1;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 4vw;
    padding: 3vw 0;
    font-weight: 500;
    overflow-x: hidden;
    overflow-y: auto;
    .row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .column{
        text-align: center;
      }
    }
  }
}
.ruleBox{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4vw;
  margin-top: 5vw;
  .title{
    color: #FFFFFF;
    font-weight: 700;
    font-size: 4.5vw;
  }
  .ruleContent{
    color: #A1A1A1;
    font-size: 3.888vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Invitee/rules.vue